import request from '@/utils/request';

export function VIPmanagementAPI() {
  return {
    // 列表
    VIPmanagementList: params => {
      return request({
        url: '/admin/auth/vip/list',
        method: 'get',
        params,
      });
    },
    // 角色组
    roleList: params => {
      return request({
        url: '/admin/group/list',
        method: 'get',
        params,
      });
    },
     // 小程序名称列表
     applicationList: params => {
      return request({
        url: '/admin/mapps/list',
        method: 'get',
        params,
      });
    },
    //新增
    VIPAdded: data => {
      return request({
        url: '/admin/auth/vip/edit',
        method: 'post',
        data
      });
    },
      // 详情数据
      detailsList: params => {
        return request({
          url: `/admin/auth/vip/info?id=${params}`,
          method: 'get',
        });
      },
  };
}
